import React, { useCallback, useEffect, useState } from "react";
import NavBar from "../../components/navbar/navbar.component";
import SideBar from "../../components/sidebar/sidebar.component";
import { useDispatch, useSelector } from "react-redux";
import { getCustomers } from "../../state/actions/rider.actions";
import Select from "react-select";
import moment from "moment";
moment().format();

const reportTypeOptions = [
  { value: "Revenue Summary", label: "Revenue Summary By Marchant" },
  { value: "by_product", label: "Revenue Report By Product Type " },
  { value: "by_detail", label: "Revenue Detail" },
];

const RevenueReport = () => {
  const dispatch = useDispatch();

  const [reportType, setReportType] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [startDate, setStartDate] = useState("2022-09-01");
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const showCustomer = reportType?.value === "revenue_summary";

  useEffect(() => {
    dispatch(getCustomers()).then((res) => {
      const custs = res.map((c) => ({
        label: c.companyName
          ? c.firstName + " " + c.lastName + " ( " + c.companyName + " )"
          : c.firstName + " " + c.lastName,
        value: c.firstName,
      }));
      const custSorted = custs.sort((a, b) => {
        const nameA = a.value?.toLowerCase();
        const nameB = b.value?.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      setCustomerOptions(custSorted);
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const params = {
      reportType: reportType?.value,
      customer: showCustomer ? customer?.value : null,
      start: startDate,
      end: endDate,
    };

    console.log("Revenue Report params :>>", params);
    // TODO: dispatch your revenue report action here
    // e.g. dispatch(getRevenueReport(params));
  };

  return (
    <>
      <NavBar />
      <SideBar />

      <div className="content-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">Revenue Report</h4>
                  </div>
                </div>

                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="d-flex flex-column">
                      {/* Report Type */}
                      <div className="col-sm-6 col-lg-4 d-flex align-items-center pl-0 mb-3">
                        <p
                          style={{ fontSize: "14px" }}
                          className="col-6 col-sm-4 col-lg-5 col-xl-4 text mb-0"
                        >
                          Report Type:
                        </p>
                        <Select
                          className="col-6 col-sm-7 col-xl-8 px-0"
                          options={reportTypeOptions}
                          value={reportType}
                          isSearchable={false}
                          isClearable={true}
                          onChange={(selected) => {
                            setReportType(selected);
                            setCustomer(null);
                          }}
                          placeholder="Select type..."
                        />
                      </div>

                      {/* Customer — only visible for "Revenue Summary" */}
                      {showCustomer && (
                        <div className="col-sm-6 col-lg-4 d-flex align-items-center pl-0 mb-3">
                          <p
                            style={{ fontSize: "14px" }}
                            className="col-6 col-sm-4 col-lg-5 col-xl-4 text mb-0"
                          >
                            Customer:
                          </p>
                          <Select
                            className="col-6 col-sm-7 col-xl-8 px-0"
                            options={customerOptions}
                            value={customer}
                            isSearchable={true}
                            isClearable={true}
                            onChange={setCustomer}
                            placeholder="Select customer..."
                          />
                        </div>
                      )}

                      {/* Start Date */}
                      <div className="col-sm-6 col-lg-4 d-flex align-items-center pl-0 mb-3">
                        <p
                          style={{ fontSize: "14px" }}
                          className="col-6 col-sm-4 col-lg-5 col-xl-4 text mb-0"
                        >
                          Start Date:
                        </p>
                        <input
                          className="col-6 col-sm-7 col-xl-8 form-control form-control-sm"
                          type="date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>

                      {/* End Date */}
                      <div className="col-sm-6 col-lg-4 d-flex align-items-center pl-0 mb-3">
                        <p
                          style={{ fontSize: "14px" }}
                          className="col-6 col-sm-4 col-lg-5 col-xl-4 text mb-0"
                        >
                          End Date:
                        </p>
                        <input
                          className="col-6 col-sm-7 col-xl-8 form-control form-control-sm"
                          type="date"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>

                      {/* Submit */}
                      <div className="col-12 d-flex justify-content-end mb-3">
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary"
                          disabled={!reportType}
                        >
                          Export
                        </button>
                      </div>
                    </div>
                  </form>

                  {/* Results area — populate once you wire up the action */}
                  {!reportType && (
                    <p className="text-muted text-center mt-4">
                      Please select a report type to continue.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RevenueReport;